import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import moment from 'moment';
import _ from 'lodash';

import { getStudyResources, sortByDate, sortByName } from '../../../../actions/supportActions';
import { CROSSTAB_FEATUREID, SUPPORT_MENU_NAME } from '../../../../constants';

import CommonStudySelector from '../../../common/CommonStudySelector';
import StudiesTable from './StudiesTable';
import WarningIcon from '../../../../containers/WarningIcon';

class Studies extends Component {
  state = {
    activeStudy: '',
    data: [],
    actualData: [],
    loading: true,
    sortColumnName: 'Uploaded',
    sortDirection: 'desc',
  }

  componentDidMount() {
    this.mounted = true;
    const { supportResourcesStudy } = this.props;
    if (supportResourcesStudy) {
      this.getSudyResource(supportResourcesStudy);
    }
  }

  componentWillUnmount() {
    this.mounted = false;
  }

  onSort = sortColumnName => {
    const { sortDirection } = this.state;
    this.setState({ sortColumnName, sortDirection: sortDirection === 'desc' ? 'asc' : 'desc' }, () => {
      this.handleSort(sortColumnName, this.state.sortDirection);
    });
  }

  getScrollbarWidth = () => {
    // Creating invisible container
    const outer = document.createElement('div');
    outer.style.visibility = 'hidden';
    outer.style.overflow = 'scroll'; // forcing scrollbar to appear
    outer.style.msOverflowStyle = 'scrollbar'; // needed for WinJS apps
    document.body.appendChild(outer);
    // Creating inner element and placing it in the container
    const inner = document.createElement('div');
    outer.appendChild(inner);
    // Calculating difference between container's full width and the child width
    const scrollbarWidth = (outer.offsetWidth - inner.offsetWidth);
    // Removing temporary elements from the DOM
    outer.parentNode.removeChild(outer);
    return scrollbarWidth;
  }

  getSudyResource = study => {
    this.setState({ activeStudy: study });
    getStudyResources(this.props.category, study.st)
      .then(response => {
        if (this.mounted) {
          if (response.actualData.length > 0) {
            this.setState({
              data: response.sortedData,
              actualData: response.actualData,
              loading: false,
            });
          } else {
            this.setState({ data: [], actualData: [], loading: false });
          }
        }
      });
  }

  getOffsetDate = date => {
    const fieldDate = new Date(date);
    fieldDate.setMinutes(fieldDate.getMinutes() + fieldDate.getTimezoneOffset());
    return moment(fieldDate).format('MM/DD/YYYY');
  }

  setSelectedStudy = selectedStudy => {
    this.setState({ data: [], loading: true }, () => {
      this.getSudyResource(selectedStudy);
    });
  }

  handleSort = (sortColumnName, sortDirection) => {
    const data = [...this.state.actualData];
    const sortedData = [];
    if (sortColumnName === 'Uploaded') {
      _.map(data, item => {
        sortedData.push(sortByDate(item, sortDirection));
      });
    } else if (sortColumnName === 'Name') {
      _.map(data, item => {
        sortedData.push(sortByName(item, sortDirection));
      });
    }
    this.setState({ data: sortedData });
  };


  checkForScroll = () => {
    setTimeout(() => {
      const hasScroll = $('.custom-mri-table--body').get(0).scrollHeight > $('.custom-mri-table--body').height();
      if (hasScroll) {
        const scrollWidth = this.getScrollbarWidth();
        $('.custom-mri-table').addClass('has-scroll');
        $('.custom-mri-table .custom-mri-table--head').attr('style', `padding-right: ${scrollWidth}px`);
      } else {
        $('.custom-mri-table').removeClass('has-scroll');
        $('.custom-mri-table .custom-mri-table--head').removeAttr('style');
      }
    }, 500);
  }

  renderResources = () => {
    const { data, sortColumnName, sortDirection } = this.state;
    const renderTable = (
      <StudiesTable
        onSort={this.onSort}
        sortColumnName={sortColumnName}
        sortDirection={sortDirection}
        data={data[0]}
        checkForScroll={this.checkForScroll}
      />
    );

    return (
      <div className="custom-tab">
        <div className="custom-tab--body custom-tab-block">
          <div className="support-user-guide-table">
            {renderTable}
          </div>
        </div>
      </div>
    );
  }


  render() {
    const { studies, supportResourcesStudy } = this.props;

    if (!studies || _.isEmpty(studies)) {
      return (
        <div className="no-study-message">
          <WarningIcon />
          <p>
          There are no active subscriptions on your account, please contact your Account Representative.
          </p>
        </div>
      );
    }

    const { activeStudy, data, loading } = this.state;
    const fieldStart = activeStudy.fs;
    const fieldEnd = activeStudy.fe;

    let renderContent = '';

    if (_.isEmpty(data) && loading) {
      renderContent = (
        <div className="resources-main-container" style={{ paddingLeft: 0 }}>
          <div className="custom-tab">
            loading....
          </div>
        </div>
      );
    }


    if (_.isEmpty(data) && !loading) {
      renderContent = (
        <div className="resources-main-container" style={{ paddingLeft: 0 }}>
          <div className="custom-tab">
            No records found.
          </div>
        </div>
      );
    }

    if (data.length > 0 && !loading) {
      renderContent = this.renderResources();
    }

    return (
      <div className="resources-main-container study-resources">
        <div className="resources-study-selector">
          <div>
            <CommonStudySelector
              studies={studies}
              featureID={CROSSTAB_FEATUREID}
              defaultStudy={supportResourcesStudy}
              setMethod={this.setSelectedStudy}
              menuName={SUPPORT_MENU_NAME}
            />
          </div>
          {fieldStart && fieldEnd && (
            <div className="resources-study-field-date">
              <div className="resources-study-field-date--label">Field Dates</div>
              <div className="resources-study-field-date--dates">
                {this.getOffsetDate(fieldStart)} - {this.getOffsetDate(fieldEnd)}
              </div>
            </div>
          )}
        </div>
        <div className="study-resources-main">
          {renderContent}
        </div>
      </div>
    );
  }
}

Studies.propTypes = {
  category: PropTypes.instanceOf(Object),
  studies: PropTypes.instanceOf(Array),
  supportResourcesStudy: PropTypes.instanceOf(Object),
};

const mapStateToProps = ({ support }) => {
  return ({
    studies: support.docStudies,
    supportResourcesStudy: support.docInitialStudy,
  });
};

export default connect(mapStateToProps)(Studies);
